import { OverlayTrigger, Tooltip } from "react-bootstrap";

const Tag = ({ label, value }) => {
    if (!value) return null;

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(value);
        } catch (e) {
            console.error("Copy failed", e);
        }
    };

    return (
        <OverlayTrigger
            placement="top"
            overlay={<Tooltip>{value}</Tooltip>}
        >
            <button
                type="button"
                onClick={copy}
                className="btn btn-outline-secondary btn-sm me-1"
                style={{
                    fontSize: "11px",
                    padding: "2px 6px",
                    lineHeight: 1.2,
                }}
            >
                {label}
            </button>
        </OverlayTrigger>
    );
};

export default function CounterTags({ tx }) {
    // ✅ 1. Только income
    if (tx.direction !== "income") return null;

    // ✅ 2. Только business
    if (tx.categoryType !== "business") return null;

    // ✅ 3. Исключаем банковские зачисления
    const description = (tx.description || "").toLowerCase();
    if (description.includes('універсал банк') || description.includes('universal bank')) {
        return null;
    }

    // ✅ 4. Если вообще нет данных — не рендерим
    if (!tx.counterName && !tx.counterIban && !tx.counterEdrpou) {
        return null;
    }

    return (
        <div className="counter-tags d-inline-flex align-items-center">
            <Tag label="ПІБ"  value={tx.counterName} />
            <Tag label="IBAN" value={tx.counterIban} />
            <Tag label="ІПН"  value={tx.counterEdrpou} />
        </div>
    );
}
